import { Component, OnInit, Input } from '@angular/core';
import { Blobs } from 'my-lib-sanfelici/my-lib-sanfelici';

@Component({
  selector: 'app-blob-display',
  templateUrl: './blob-display.component.html',
  styleUrls: ['./blob-display.component.scss']
})
export class BlobDisplayComponent implements OnInit {
@Input() blob:Blobs;
  constructor() { }

  ngOnInit() {
  }

}
